module.exports = __webpack_public_path__ + "img/house-user.0d86062e.svg";